import type {
  AiEntityChunk,
  AiSummaryChunk,
  NormalizedEntityForStore,
  NormalizedSummaryForStore,
} from '@/common/document-viewer/types'

import { DocumentViewerActionTypes } from './action_types'
import { DocumentViewerMutationTypes } from './mutation_types'
import filesService from '../../../services/files.service'

export const actions: StoreActions<DocumentViewerActionTypes, DocumentViewerMutationTypes> = {
  async [DocumentViewerActionTypes.REDACT_DOCUMENT] ({ commit }, { mnemo, fileId, data }) {
    commit(DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR, null)
    try {
      await filesService.redactDocument(mnemo, fileId, data)
    } catch (error) {
      commit(DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_ERROR, error)
      throw error
    }
  },
  async [DocumentViewerActionTypes.SEARCH_BY_AI] ({ commit }, { mnemo, fileId }) {
    commit(DocumentViewerMutationTypes.SEARCH_BY_AI_ERROR, null)
    commit(DocumentViewerMutationTypes.SEARCH_BY_AI_PENDING, true)
    commit(DocumentViewerMutationTypes.SET_SEARCH_BY_AI_RESULTS, {
      results: {},
      summary: null,
    })

    try {
      await filesService.searchByAiStream(mnemo, fileId, {
        // Chunk detected entity
        onEntity: (chunk: AiEntityChunk) => {
          const normalized: NormalizedEntityForStore = {
            type: chunk.type,
            text: chunk.value,
            id: String(chunk.entity_id),
          }
          commit(DocumentViewerMutationTypes.SEARCH_BY_AI_PUSH_ENTITY, normalized)
        },
        // Chunk final summary
        onSummary: (summaryChunk: AiSummaryChunk) => {
          const normalizedSummary: NormalizedSummaryForStore = {}
          summaryChunk.entities.forEach(entity => {
            if (!normalizedSummary[entity.type]) {
              normalizedSummary[entity.type] = {}
            }
            normalizedSummary[entity.type][entity.norm] = entity.values ?? entity.ids ?? []
          })
          commit(
            DocumentViewerMutationTypes.SEARCH_BY_AI_SET_SUMMARY,
            normalizedSummary,
          )
        },
        // Streaming error
        onError: (error: Error) => {
          // Remove partial results on error
          commit(DocumentViewerMutationTypes.SET_SEARCH_BY_AI_RESULTS, {
            results: {},
            summary: null,
          })
          commit(DocumentViewerMutationTypes.SEARCH_BY_AI_ERROR, error)
        },
      })
    } catch (error) {
      // Ensure cleared even if thrown before onError
      commit(DocumentViewerMutationTypes.SET_SEARCH_BY_AI_RESULTS, {
        results: {},
        summary: null,
      })
      commit(DocumentViewerMutationTypes.SEARCH_BY_AI_ERROR, error as Error)
      throw error
    } finally {
      commit(DocumentViewerMutationTypes.SEARCH_BY_AI_PENDING, false)
    }
  },
}
